import { ContractColumnConfigurationsLoaded } from "./contracts.actions";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import { ContractColumnConfigurations, defaultContractColumns } from "./ContractListColumns";
import { ColumnCustomization } from "common/agGrid/columnCustomization";

export default class ContractColumnConfigurationsReducer extends ReducerBase<ContractColumnConfigurations> {

    constructor() {
        super();
        
        this.addHandler(ContractColumnConfigurationsLoaded.EventName, this.handleConfigLoaded);
    }

    handleConfigLoaded(state: ContractColumnConfigurations = initialState.contractColumnConfigurations, 
        event: ContractColumnConfigurationsLoaded): ContractColumnConfigurations {
        // return event.columnConfigs; 
        const getCols = (getter: (c: ContractColumnConfigurations) => ColumnCustomization): ColumnCustomization => {
            let customization = getter(event.columnConfigs)

            if (customization?.visibleColumns == null || customization.visibleColumns.length === 0) {
                customization = getter(defaultContractColumns);
            }

            return customization;
        }
        return {
            basis: getCols(m => m.basis),
            cash: getCols(m => m.cash),
            hta: getCols(m => m.hta),
            delayedPrice: getCols(m => m.delayedPrice),
            withOptions: getCols(m => m.withOptions)
        }
    }

    handleDefault(state: ContractColumnConfigurations = initialState.contractColumnConfigurations) {
        return state;
    }
}
